import { useState } from 'react';
import { useDispatch, useReduxState } from 'hooks';
import { userLocalCache } from 'lib/reader';
import { Button } from 'components/common';
import { DropdownButton } from 'components/common/dropdown';
import {
  Modal,
  ModalFooter,
  ModalContent,
  ModalPortal
} from 'components/common/modal';

const HeaderGuestLogout = () => {
  const {
    messages,
    pageState: { courseSlug },
    user
  } = useReduxState();

  const { dispatch } = useDispatch();

  const [modalVisible, setModalVisible] = useState(false);

  const deleteData = () => {
    // delete guestId from cookie
    // eslint-disable-next-line react-hooks/immutability
    document.cookie =
      'guestId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    // clear user local cache
    userLocalCache.clearData({ userId: user?.id });
    // handle logout normally
    logout();
  };

  const logout = () => {
    dispatch.logout(courseSlug ? `/login/${courseSlug}` : '/login');
  };

  const hideModal = () => {
    setModalVisible(false);
  };

  const showModal = () => {
    setModalVisible(true);
  };

  return (
    <>
      <DropdownButton
        icon="sign-out-alt"
        onClick={showModal}
        text={messages.headerSignOut}
      />
      <ModalPortal>
        <Modal
          onHide={hideModal}
          title={messages.headerSignOut}
          visible={modalVisible}
        >
          <ModalContent>{messages.headerGuestLogoutInfo}</ModalContent>
          <ModalFooter>
            <Button
              category="danger"
              onClick={deleteData}
              text={messages.headerGuestLogoutDelete}
            />
            <Button
              onClick={logout}
              text={messages.headerGuestLogoutRemember}
            />
          </ModalFooter>
        </Modal>
      </ModalPortal>
    </>
  );
};

export default HeaderGuestLogout;
